import { plainToClass } from 'class-transformer';
import {
  API_SERVICE_CODE_CREATE,
  API_SERVICE_CODE_DELETE,
  API_SERVICE_CODE_FIND_ALL,
  API_SERVICE_CODE_FIND_ONE,
  API_SERVICE_CODE_UPDATE
} from '../api.routes';
import { BaseApi } from './base.api';
import { ServiceCodeDto } from '../dto';
import { FindAllResponse } from '../types';

export class ServiceCodeApi extends BaseApi {
  /**
   * Find all
   */
  public findAll(params): Promise<FindAllResponse<ServiceCodeDto>> {
    return this.httpClient
      .get(API_SERVICE_CODE_FIND_ALL, { params })
      .then(({ data }) => {
        return {
          ...data,
          items: plainToClass(ServiceCodeDto, data.items)
        };
      });
  }

  /**
   * Find one
   * @param uuid
   */
  public findOne(uuid: string): Promise<ServiceCodeDto> {
    return this.httpClient
      .get(API_SERVICE_CODE_FIND_ONE, { pathParams: { uuid } })
      .then(({ data }) => {
        return plainToClass(ServiceCodeDto, data);
      });
  }

  /**
   * Create
   * @param data
   */
  public create(data): Promise<ServiceCodeDto> {
    return this.httpClient
      .post(API_SERVICE_CODE_CREATE, data)
      .then(({ data }) => {
        return plainToClass(ServiceCodeDto, data);
      });
  }

  /**
   * Update
   * @param data
   */
  public update(data): Promise<ServiceCodeDto> {
    return this.httpClient
      .put(API_SERVICE_CODE_UPDATE, data)
      .then(({ data }) => {
        return plainToClass(ServiceCodeDto, data);
      });
  }

  /**
   * Delete
   * @param uuid
   */
  public delete(uuid): Promise<void> {
    return this.httpClient.delete(API_SERVICE_CODE_DELETE, {
      pathParams: { uuid }
    });
  }
}
